const BASE_URL = 'ai-service/api/ai-expressions'

const aiExpressionsRequests = {
  createAiExpressionRequest: (data) => ({
    url: BASE_URL,
    method: 'post',
    data,
  }),
  deleteAiExpressionRequest: ({ id }) => ({
    url: `${BASE_URL}/${id}`,
    method: 'delete',
  }),
  executeAiExpressionRequest: ({ id, imageUrl }) => ({
    url: `${BASE_URL}/${id}/execute`,
    method: 'post',
    data: {
      imageUrl,
    },
  }),
  updateAiExpressionRequest: (data) => ({
    url: `${BASE_URL}/${data.Id}`,
    method: 'put',
    data,
  }),
  getAiExpressionRequest: ({ id }) => ({
    url: `${BASE_URL}/${id}`,
    method: 'get',
  }),
  getAiExpressionsRequest: ({ skip, take, search }) => ({
    url: BASE_URL,
    method: 'get',
    params: {
      skip,
      take,
      search,
    },
  }),
  generateAiExpressionRequest: (data) => ({
    url: `${BASE_URL}/generate`,
    method: 'post',
    data,
  }),

  attachAiExpressionToFormControlOptionRequest: ({ expressionId, formControlOptionId }) => ({
    url: `api/formControlOptions/${formControlOptionId}/aiExpression/${expressionId}`,
    method: 'post',
  }),
  detachAiExpressionFromFormControlOptionRequest: ({ formControlOptionId }) => ({
    url: `api/formControlOptions/${formControlOptionId}/aiExpression`,
    method: 'delete',
  }),
}

export default aiExpressionsRequests
